<template>
  <TransitionGroup name="slide-down" tag="ul" class="px-5 md:py-8">
    <ResourceCard v-for="resource in resourcesToDisplay" :resource="resource" :key="`resource-${resource.id}`" />
  </TransitionGroup>
  <button v-if="resources.length !== resourcesToDisplay.length" class="button mx-auto mb-12" @click="seeMore">
    {{ $t('see_more') }}
  </button>
</template>

<script lang="ts">
import type {PropType} from 'vue'
import {ResourceCard} from '@/components/cards'

export default {
  name: 'PostList',
  components: {ResourceCard},
  data() {
    return {
      count_resourcesToDisplay: 3,
    }
  },
  props: {
    resources: {
      type: Array as PropType<Document[] | Post[]>,
      required: true,
    },
  },
  computed: {
    resourcesToDisplay(): (Document | Post)[] {
      return this.resources.slice(0, this.count_resourcesToDisplay)
    },
  },
  methods: {
    seeMore() {
      this.count_resourcesToDisplay += 10
    },
  },
}
</script>
